// extracted by mini-css-extract-plugin
export default {"indexCard":"styles_indexCard__hpjfH"};